import _ from 'lodash';

_.templateSettings = { // LoDash template settings
    interpolate: /\{\{(.+?)\}\}/g,
    evaluate: /<@(.+?)@>/g
};

const _t = {

    cmeGliderContainerTemplate: _.template(`<div class="cme-glider-container">
											  <div class="cme-activities-label">EDUCATION ACTIVITIES YOU MAY LIKE</div>
											    <div class="cme-glider" class="glider-contain">
													<div class="glider cme-glider-slide-container"></div>
													<button aria-label="Previous" class="glider-prev carousel_arrow cme-arrow" onclick="wmdPageLink('fy-cmecont_arrow', this);">
														<div class="arrows prev"></div>
													</button>
													<button aria-label="Next" class="glider-next carousel_arrow cme-arrow" onclick="wmdPageLink('fy-cmecont_arrow', this);">
														<div class="arrows next"></div>
													</button>
													<div role="tablist" class="dots"></div>
												</div>
                                                <div class="share-layer cme-share-layer">
                                                    <div class="share-icon facebook"></div>
                                                    <div class="share-icon twitter"></div>
                                                    <div class="share-icon linkedin"></div>
                                                    <div class="share-icon whatsapp"></div>
													<!-- <div class="share-icon email"></div> -->
                                                </div>
                                            </div>`),

    cmeGliderItem: _.template(`<a class="cme-card-container" rel="nofollow" draggable="false" href="{{ uri }}" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" data-img="<@ if (imageUrl != '') { @>{{ imageUrl }}?interpolation=lanczos-none&resize=310:*<@ } @>" data-credits="{{ credits }}" data-track="{{ trackingValue }}">
								<div class="cme-card-img-container"><@ if (imageUrl != '') { @><img src="{{ imageUrl }}?interpolation=lanczos-none&resize=310:*" alt=""><@ } @></div>
								<div class="cme-card-inner-container">
									<div class='cme-label'><span class="accredited">{{ creditLabel }}</span> <span class="cme-text">{{ creditType }}</span></div>
									<div class='cme-desc'>{{ title }}</div>
									<div class='cme-subheader'><div class="pers-pubname">{{ publicationName }}</div><div class="pers-date">{{ publicationDate }}</div></div>
									<div class="cme-share-container">
											<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span></div></div>
											<div class="pers-share cme-share" data-href="{{ contentId }}"><div class="pers-share-text"></div></div>
											<div class="pers-save" data-href="{{ contentId }}"></div>
									</div>
								</div>
							</a>`),

    cmeGliderGhostItem: _.template(`<a class="cme-card-container ghost" draggable="false"></a>`),

	cmeGenericTemplate: _.template(`<div class="cme-glider-container">
									<div class="cme-activities-label">EDUCATION ACTIVITIES YOU MAY LIKE</div>
										<div class="cme-glider cme-generic-container" class="glider-contain">

										</div>
									<div class="share-layer cme-share-layer generic-cme-share-layer">
										<div class="share-icon facebook"></div>
										<div class="share-icon twitter"></div>
										<div class="share-icon linkedin"></div>
										<div class="share-icon whatsapp"></div>
										<!-- <div class="share-icon email"></div> -->
									</div>
								</div>`),
};

export default _t;